import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '@t90/ui';

export function ProductionPage() {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-3xl font-bold tracking-tight">Production</h1>
        <p className="text-muted-foreground">
          Log and track daily production metrics
        </p>
      </div>

      <Card>
        <CardHeader>
          <CardTitle>Production Logging</CardTitle>
          <CardDescription>
            Daily production logging interface coming soon...
          </CardDescription>
        </CardHeader>
        <CardContent>
          <p className="text-sm text-muted-foreground">
            This page will allow team leads to log daily production for trainees,
            including units completed, hours worked, and project assignments.
          </p>
        </CardContent>
      </Card>
    </div>
  );
}
